// extracted by css-extract-rspack-plugin
export default {"container":"loppD","icon":"vlgxO","button_override":"sNXiD","buttonOverride":"sNXiD","#":"BovPl","label":"qo2V8"};